import module from 'usuarios/module.js'
import template from './template.html'

export class UsuariosListaComponent {
  data = []
  onChange = null
  completado = false
  q = ''
  deshabilitado = false

  $onChanges(changes){
    if(changes.data) {
      this.deshabilitado = false
    }
  }

  regresar () {
    this.deshabilitado = true
    this.onChange({$event: {detail: this.q}})
  }

  buscar () {
    this.onChange({$event: {detail: this.q}})
  }
}

module.component('usuariosLista', {
  controller: UsuariosListaComponent,
  template,
  bindings: {
    data: '<',
    onChange: '&',
    completado: '<',
  }
})



// WEBPACK FOOTER //
// ./src/usuarios/components/lista/component.js